var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLiveChatEmojiIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_160483",
    "data-name": "Group 160483",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.43,
    height: 17.429,
    viewBox: "0 0 17.43 17.429",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1944",
    "data-name": "Rectangle 1944",
    width: 17.43,
    height: 17.429,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "smile",
    transform: "translate(1.089 1.089)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 7.625,
    cy: 7.625,
    rx: 7.625,
    ry: 7.625,
    fill: "none",
    stroke: "#647084",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M8,14a4.49,4.49,0,0,0,5.927,0",
    transform: "translate(-3.4 -5.182)",
    fill: "none",
    stroke: "#647084",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    "data-name": "Line 4",
    x2: 0.006,
    transform: "translate(5.331 4.847)",
    fill: "none",
    stroke: "#647084",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    x2: 0.006,
    transform: "translate(9.799 4.847)",
    fill: "none",
    stroke: "#647084",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveChatEmojiIcon);
export default __webpack_public_path__ + "static/media/live-chat-emoji-icon.3476c8fd4be436b176d8ce394c301ddd.svg";
export { ForwardRef as ReactComponent };